import React from 'react';

import './style.sass';

const ContentCaseHeader = ({ listTitle }) => {
    return (
        <>
            {listTitle.map((item, index) => (
                <div className="content-case__header-inner desktop:w-8/12" key={index}>
                    <div className="content-case__header">
                        <h1
                            className="content-case__title"
                            dangerouslySetInnerHTML={{ __html: item.title }}
                        />
                    </div>
                </div>
            ))}
        </>
    );
};

export default ContentCaseHeader;
